var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPatrigestBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1922,
    height: 617,
    viewBox: "0 0 1922 617",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 352.7L108.899 387.892C139.001 397.919 159.222 425.361 159.222 456.25L159.222 617H236L236 456.25C236 393.577 194.957 337.842 133.83 317.473L0 274L0 352.7Z",
    fill: "url(#paint0_linear_13_3047)",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1260 338L1260 188.785L1146.37 188.785C1066.42 188.785 1001.38 123.823 1001.38 43.966L1001.38 -1.78139e-06L852 0L852 43.8763C852 206.012 984.048 337.91 1146.37 337.91L1260 337.91L1260 338Z",
    fill: "url(#paint1_linear_13_3047)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1719.73 530.688L1719.73 617L1789.61 617L1789.61 530.688C1789.61 493.234 1819.97 462.871 1857.42 462.871L1921.13 462.871L1921.13 393L1857.42 393C1781.38 393 1719.73 454.645 1719.73 530.688Z",
    fill: "url(#paint2_linear_13_3047)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1857.38 571.749C1880.08 571.749 1898.49 553.347 1898.49 530.648C1898.49 507.948 1880.08 489.547 1857.38 489.547C1834.68 489.547 1816.28 507.948 1816.28 530.648C1816.28 553.347 1834.68 571.749 1857.38 571.749Z",
    fill: "#FF7878",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_3047",
    x1: -32.9509,
    y1: 346.865,
    x2: 319.727,
    y2: 822.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28C5FA",
    stopOpacity: 0.913179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563943,
    stopColor: "#28C5FA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981417,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13_3047",
    x1: 663.21,
    y1: -9.06868,
    x2: 1245.16,
    y2: 394.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9378FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#9378FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13_3047",
    x1: 1714.33,
    y1: 720.649,
    x2: 1929.24,
    y2: 384.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF7878",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatrigestBg);
export default __webpack_public_path__ + "static/media/patrigest-bg.5c9bd767709bf7cccb68a0721eb73369.svg";
export { ForwardRef as ReactComponent };